export default __webpack_public_path__ + "static/media/non-active-info.1e748088.svg";